const ErrorCodes = {
    REQUIRED: "REQUIRED",
    WRONG_EMAIL: "WRONG_EMAIL",
    NO_RUSSIAN_MOBILE_PHONE: "NO_RUSSIAN_MOBILE_PHONE",
    NO_RUSSIAN_PHONE: "NO_RUSSIAN_PHONE",
    REQUIRED_AS_MESSAGE: "REQUIRED_AS_MESSAGE",
};

export default ErrorCodes;